






import { Component, Vue, Prop } from "vue-property-decorator";
import Header from "./components/main-header/main-header.vue";
@Component({
  components: {
    Header,
  },
})
export default class MainView extends Vue {
  private msg!: string;
  private logoutInterval: any = {};
  /**
   * @description 倒计时函数
   */
  private timeLogoutDecline() {
    const currentTimer = this.$store.state.logoutTimer;
    if (currentTimer <= 1) {
      this.$message.error("您太长时间没有操作了，请重新登录");
      this.$store.commit("updateToken", "");
      this.$router.push("/access/login");
    }
    this.$store.commit("updateLogoutTimer", currentTimer - 1);
  }
  /**
   * @description 鼠标移动后重新计时
   */
  private resetLogoutTimer() {
    this.$store.commit("updateLogoutTimer", 3 * 60 * 60);
  }
  /**
   * @description 无操作退出倒计时
   */
  private mounted() {
    this.logoutInterval = setInterval(this.timeLogoutDecline, 1000);
  }
  /**
   * @description 销毁倒计时
   */
  private destroyed() {
    if (this.logoutInterval) {
      clearInterval(this.logoutInterval);
    }
  }
}
